export function LightBulbIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10539 9.56248L5.10539 11.1971C5.10539 12.0025 5.75831 12.6554 6.56372 12.6554L7.43872 12.6554C8.24414 12.6554 8.89706 12.0025 8.89706 11.1971L8.89706 9.5613C10.5612 8.68833 11.4146 6.79235 10.9648 4.96779C10.515 3.14324 8.87804 1.86124 6.99886 1.86182C5.11967 1.86239 3.4835 3.1454 3.0348 4.97023C2.5861 6.79506 3.44074 8.69052 5.10539 9.56247L5.10539 9.56248Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09998 9.44694L4.90023 9.44694"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
